import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../common/createBaseQueryWithLogoutGuard";
import store from "../../../app/store";

export const _authToken = () => {
  const state = store.getState();
  return `${state?.authReducer?.userData?.tokenType?.toLowerCase()} ${
    state?.authReducer?.userData?.token
  }`;
};
export const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId ? state?.orgReducer?.selectedFI?.orgClientId : state?.authReducer?.userData?.client_Id;
};

export const _selectedIdrssd = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.idrssd;
};

export const insightsAndRecommendationSlice = createApi({
  reducerPath: "analysis_trends",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["InsightsAndRecommendation"],
  endpoints: (build) => ({
    getInsightsAndRecommendation: build.query({
      query: () => ({
        url: `bank/${_orgClientId()}/ewi/${_selectedIdrssd()}`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      providesTags: (_) => ["InsightsAndRecommendation"],
    }),
  }),
});

export const { useGetInsightsAndRecommendationQuery } =
  insightsAndRecommendationSlice;

export const useQueryStateInsightsAndRecommendation = (queryHook, args) => {
  const result = queryHook(args);
  return {
    data: result?.data?.data?.early_warning_indicators,
    adjusted_metrics: result?.data?.data?.adjusted_metrics,
    isLoading: result?.isLoading,
    isFetching: result?.isFetching,
    isError: result?.isError,
    error: result?.error,
  };
};
